import * as React from "react";
import { SVGProps } from "react";

const MeasurableDataToken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 76 75"
    {...props}
  >
    <style>{".st0{fill:#8acaff}.st1{fill:#4187f7}"}</style>
    <g id="Layer_1-2">
      <path
        d="m40.9 33.6-2.5 4.3-2.5 4.3-4.7-2.7-18.8-10.8v20.4c-3-2.2-7-2.2-10 0V26.8c3.7 2.8 9 2 11.7-1.7 1.1-1.4 1.7-3.2 1.7-5 0-.3 0-.6-.1-1l20.4 11.8 2.2 1.3 2.6 1.4zm30.6 21c.2.4.3.8.3 1.2h-7.5l3.7-2.2c1.3-.6 2.8-.2 3.5 1z"
        className="st0"
      />
      <path
        d="M74.3 26.8v22.3c-3-2.2-7-2.2-10 0V28.7L45.6 39.5l-4.7 2.7-2.5-4.3-2.5-4.3 2.5-1.4 2.2-1.3L61 19.1c0 .3-.1.6-.1 1 0 4.6 3.8 8.4 8.4 8.4 1.8 0 3.6-.6 5-1.7zM39.7.1c-.1-.1-.1-.1 0 0l-.1-.1h-2L13.1 13.9c1.3 1.2 2.1 2.7 2.5 4.3L35.9 6.5v15c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-15l20.3 11.7c.4-1.7 1.2-3.2 2.5-4.3L39.7.1zm32.1 55.7h-7.5l3.7-2.2c1.2-.7 2.7-.3 3.4.9.3.4.4.9.4 1.3zm-10.7 1.9L40.9 69.4v-15c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v15L15.6 57.7c-.4 1.7-1.2 3.2-2.5 4.3l24 13.8h2.2c.1 0 .2-.1.2-.1h.3l24-13.8c-1.4-1.1-2.3-2.6-2.7-4.2z"
        className="st0"
      />
      <circle cx={38.4} cy={37.9} r={7.4} className="st1" />
      <circle cx={7.4} cy={20.1} r={7.4} className="st1" />
      <circle cx={7.4} cy={55.8} r={7.4} className="st1" />
      <circle cx={69.3} cy={20.1} r={7.4} className="st1" />
      <circle cx={69.3} cy={55.8} r={7.4} className="st1" />
    </g>
  </svg>
);

export default MeasurableDataToken;
